<template>
    <div class="team-arrival-area-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'teamArrivalDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Route Details</div>
                    </div>

                    <div class="col-md-4">
                        <!-- <div class="top-navbar-right">
                            <button class="btn btn-ecdc">Export Report</button>
                        </div> -->
                    </div>
                </div>
            </div>

            <hr />

            <div class="reference-card">

              <h2 class="section-title">Showing Results For:</h2>
              
              <div class="table-responsive">
                <table class="table table-striped result-table reference-table">
                  <thead>
                      <tr>
                          <th>Team Name</th>
                          <th>Total Checked in Location</th>
                          <th>Number of Ba</th>
                          <th>Last Check in Area</th>
                          <th>Status</th>
                      </tr>
                  </thead>

                  <tbody>
                      <tr>
                          <td>{{ workProgress.team_name }}</td>
                          <td>{{ workProgress.location_count }}</td>
                          <td>{{ workProgress.ba_count }}</td>
                          <td>{{ workProgress.area_name }}</td>
                          <td v-if="workProgress.status!=null">Offline</td>
                          <td v-if="workProgress.status==null">Active</td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div class="row">
                <div class="col-lg-7">
                    <div class="table-responsive">
                      <table class="table table-striped table-hover result-table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>venue</th>
                                <th>district</th>
                                <th>category</th>
                                <th>check in</th>
                                <th>check out</th>
                                <th class="text-center">action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(checkin, index) in checkinData" v-bind:key="checkin.id">
                                <td>{{ checkinData.length - index }}</td>
                                <td>{{ checkin.venue_name }}</td>
                                <td>{{ checkin.district }}</td>
                                <td>{{ checkin.category }}</td>
                                <td>{{ checkin.check_in_time }}</td>
                                <td v-if="checkin.check_out_time">{{ checkin.check_out_time }}</td>
                                <td v-if="!checkin.check_out_time"><label class="badge live-badge">LIVE</label></td>
                                <td class="text-center"><button class="btn btn-link" type="button" @click="view(checkin.id, checkin.venue_id)">
                                  View <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" /></button></td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                </div>

                <div class="col-lg-5">
                    <div id="cdcMap"></div>
                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { routeDetails } from "../api";
import Loader from "./Loader.vue";

export default {
  components: {
    appLoader: Loader
  },
  data() {
    return {
      id: this.$route.params.id,
      styledMapType: "",
      map: "",
      checkinData: [],
      workProgress: "",
      isLive: false,
      isLoading: true
    };
  },
  async mounted() {
    this.styledMapType = new window.google.maps.StyledMapType(
      [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#242f3e"
            }
          ]
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#746855"
            }
          ]
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#242f3e"
            }
          ]
        },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "poi.business",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#263c3f"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#6b9a76"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#38414e"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#212a37"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9ca5b3"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#746855"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#1f2835"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#f3d19c"
            }
          ]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#2f3948"
            }
          ]
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#17263c"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#515c6d"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#17263c"
            }
          ]
        }
      ],
      { name: "Styled Map" }
    );
    await this.getData();

    this.isLoading = false;
  },
  methods: {
    async getData() {

        const _this = this;

        try {
          const result = await routeDetails({ work_progress_tl_id: this.id });

          this.workProgress = result.data.data.top_result;
          this.checkinData = result.data.data.work_progress_by_teams.result;
          
          const { latitude, longitude } = this.checkinData.length > 0
              ? this.checkinData[0]
              : {
                  latitude: "-0.789300",
                  longitude: "113.921300",
                };

          this.map = new window.google.maps.Map(document.getElementById("cdcMap"), {
              center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
              scrollwheel: false,
              zoom: 14
          });
          this.map.mapTypes.set("styled_map", this.styledMapType);
          this.map.setMapTypeId("styled_map");

          if(this.checkinData.length > 0 && this.checkinData[0].check_out_time == null ) {
              
              this.isLive = true;
          }

          this.checkinData.forEach(function(item, index) {

              if(item.check_out_time != null) {

                  var template = [
                      '<svg xmlns="http://www.w3.org/2000/svg" width="24.558" height="31.617" viewBox="0 0 24.558 31.617">',
                      '<g id="pin-yellow-sequence" transform="translate(-1318.569 -659.191)">',
                      '<g id="maps-and-flags" transform="translate(1261.418 659.191)">',
                      '<path id="Path_57" data-name="Path 57" d="M81.71,12.279c0,9.832-11.1,18.939-11.1,18.939a1.942,1.942,0,0,1-2.359,0s-11.1-9.106-11.1-18.939a12.279,12.279,0,0,1,24.559,0Z" fill="#fdcd08"/>',
                      '<path id="Path_58" data-name="Path 58" d="M165.417,117.721a9.458,9.458,0,1,1,9.458-9.458A9.468,9.468,0,0,1,165.417,117.721Z" transform="translate(-95.986 -95.984)" fill="#2b4162"/>',
                      '</g>',
                      '<text id="_1" data-name="1" transform="translate(1334 675.5)" fill="#fdcd08" font-size="12" font-family="Arial-BoldMT, Arial" font-weight="700" text-anchor="middle"><tspan x="-3.337" y="0">',
                      _this.checkinData.length - index,
                      '</tspan></text>',
                      '</g>',
                      '</svg>'
                  ].join("\n");

                  new window.google.maps.Marker({
                      position: {
                          lat: parseFloat(item.latitude),
                          lng: parseFloat(item.longitude)
                      },
                      animation: window.google.maps.Animation.DROP,
                      map: _this.map,
                      icon: {
                          url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template),
                          scaledSize: new window.google.maps.Size(40, 40)
                      },
                      title: "check in"
                  });
              }
              else {

                  var image = require("@/assets/img/pin-live.svg");

                  new window.google.maps.Marker({
                      position: {
                          lat: parseFloat(item.latitude),
                          lng: parseFloat(item.longitude)
                      },
                      animation: window.google.maps.Animation.DROP,
                      map: _this.map,
                      icon: image,
                      title: "live"
                  });
              }
          });
        }
        catch(err) {

          alert(err.message);
        }
    },
    view(id, venue_id) {
      this.$router.push({ name: 'teamArrivalAreaDetails', params: { 'id': this.id, 'venue_id': venue_id } });
    },
  }
};
</script>

<style scoped>
#cdcMap {
  width: 100%;
  height: 550px;
}
</style>